import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Modal from "../../components/Modal/Modal";
import useAuth from "../../hooks/useAuth";
import AddUnderContractData from "../../pages/UnderContract/components/AddUnderContractData";
import { BASE_URL } from "../../utils/Element";

const initialData = {
  executed_id: "",
  property: { id: "", name: "" },
  company_gcl: "",
  contract_price: "",
  contract_cap_rate: "",
  contract_date: "",
  gcl_broker_representing_seller: "",
  gcl_broker_representing_buyer: "",
  gcl_bds_seller: "",
  gcl_bds_buyer: "",
};


const ContractModal = ({ showModal, onClose, onSuccess, onCallApi, id }) => {
  const [config] = useAuth();
  const [disable, setDisable] = useState(false);
  const [addexecutedData, setExecutedData] = useState(initialData);
  const [addpipelineError, setAddpipelineError] = useState({ pipelinename: "" });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDollar, setIsDollar] = useState(false)
  const [loading, setLoading] = useState(false);
  const [isSellerBDSDollar, setIsSellerBDSDollar] = useState(false)
  const [isBuyerBDSDollar, setIsBuyerBDSDollar] = useState(false)
  const [isSellerBrokerDollar, setIsSellerBrokerDollar] = useState(false)
  const [isBuyerBrokerDollar, setIsBuyerBrokerDollar] = useState(false)


  const handleClose = () => {
    setDisable(false);
    setExecutedData(initialData);
    onClose();
  };

  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      axios
        .get(`${BASE_URL}/getby-id-executed/${id}`, config)
        .then((res) => {
          const data = res?.data;
          setIsDollar(data?.executed?.company_gcl_type === 'dollar' ? true : false);
        setIsSellerBDSDollar(data?.executed?.seller_bds_type === 'dollar' ? true : false);
        setIsBuyerBDSDollar(data?.executed?.buyer_bds_type === 'dollar' ? true : false);
        setIsSellerBrokerDollar(data?.executed?.seller_broker_type === 'dollar' ? true : false);
        setIsBuyerBrokerDollar(data?.executed?.buyer_broker_type === 'dollar' ? true : false);
          setExecutedData({
            property: {
              id: data?.executed?.link?.id,
              name: data?.executed?.link?.property_name,
            },
            portfolio: data?.portfolio === 1 ? 1 : 0,
            company_gcl: data?.executed?.company_gcl,
            contract_price: data?.executed?.contract_price,
            contract_cap_rate: data?.executed?.contract_cap_rate,
            gcl_broker_representing_seller: data?.executed?.gcl_broker_representing_seller,
            gcl_broker_representing_buyer: data?.executed?.gcl_broker_representing_buyer,
            gcl_bds_seller: data?.executed?.gcl_bds_seller,
            gcl_bds_buyer: data?.executed?.gcl_bds_buyer,
            company_gcl_type: isDollar ? "dollar" : "percent",
            seller_bds_type: isSellerBDSDollar ? "dollar" : "percent",
            buyer_bds_type: isBuyerBDSDollar ? "dollar" : "percent",
            seller_broker_type: isSellerBrokerDollar ? "dollar" : "percent",
            buyer_broker_type: isBuyerBrokerDollar ? "dollar" : "percent",

          });    
        })
        .catch((err) => {
          if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
            NotificationManager.error(err.response?.data?.message);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [id, showModal]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);
    const dataToSend = {
      portfolio: addexecutedData?.portfolio === 1 ? 1 : 0,
      executed_id: addexecutedData.executed_id,
      property: addexecutedData.property,
      company_gcl: addexecutedData.company_gcl,
      contract_price: addexecutedData.contract_price,
      contract_cap_rate: addexecutedData.contract_cap_rate,
      contract_date: addexecutedData.contract_date,
      gcl_broker_representing_seller: addexecutedData?.gcl_broker_representing_seller,
      gcl_broker_representing_buyer: addexecutedData?.gcl_broker_representing_buyer,
      gcl_bds_seller: addexecutedData?.gcl_bds_seller,
      gcl_bds_buyer: addexecutedData?.gcl_bds_buyer,
      created_at: addexecutedData?.created_at,
      company_gcl_type: isDollar ? "dollar" : "percent",
      seller_bds_type: isSellerBDSDollar ? "dollar" : "percent",
      buyer_bds_type: isBuyerBDSDollar ? "dollar" : "percent",
      seller_broker_type: isSellerBrokerDollar ? "dollar" : "percent",
      buyer_broker_type: isBuyerBrokerDollar ? "dollar" : "percent",
    };

    axios
      .post(`${BASE_URL}/mark-as-under-contract/${id}`, dataToSend, config)
      .then((res) => {
        handleClose();
        onCallApi();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          console.error("API Error:", err.response.data.errors);
        } else {
          console.error("Unexpected Error:", err);
        }
        setDisable(false);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const handleChange = (value, name) => {
    setExecutedData({ ...addexecutedData, [name]: value });
  };


  return (
    <Modal title={"Convert to Under Contract"} desc={"Add the Under Contract information."} show={showModal} onClose={handleClose}>
      <AddUnderContractData
        addexecutedData={addexecutedData}
        setExecutedData={setExecutedData}
        handleSubmit={handleSubmit}
        onsetExecutedData={(value) => {
          setExecutedData(value);
        }}
        isSidebarOpen={isSidebarOpen}
        isDollar={isDollar}
        setIsDollar={setIsDollar}
        isSellerBDSDollar={isSellerBDSDollar}
        setIsSellerBDSDollar={setIsSellerBDSDollar}
        isBuyerBDSDollar={isBuyerBDSDollar}
        setIsBuyerBDSDollar={setIsBuyerBDSDollar}
        isSellerBrokerDollar={isSellerBrokerDollar}
        setIsSellerBrokerDollar={setIsSellerBrokerDollar}
        isBuyerBrokerDollar={isBuyerBrokerDollar}
        setIsBuyerBrokerDollar={setIsBuyerBrokerDollar}
        showModal={showModal}
        handleChange={handleChange}
        disable={disable}
        error={addpipelineError}
        onSetError={(value) => setAddpipelineError(value)}
        onClose={handleClose}
      />
    </Modal>
  );
};

export default ContractModal;
